<template>
  <TheOnboarding />
</template>

<script>
import TheOnboarding from '@/components/Onboarding/TheOnboarding.vue'

export default {
  name: 'OnboardingPage',

  components: { TheOnboarding }
}
</script>
